<template>
  <div
    class="row f-row"
    style="font-size: 0.8rem!important; height: 1rem!important;"
  >
    <div class="col col-12 vert-align">
      <button
        class="btn detailView"
        :class="{ active: showExpo }"
        v-on:click="onShow(1)"
        style="padding-right: 2px !important;"
      >
        <span class="align-middle"
          >{{
            asset === "currencies" ? "Forecasted cash flow" : "Forecasted qty"
          }}&nbsp;</span
        >
        <div
          v-bind:class="[
            showExpo ? 'square-border-expo' : 'square-border-expo-off',
          ]"
        ></div>
      </button>

      <button
        class="btn detailView"
        :class="{ active: showBasisRatio }"
        v-on:click="onShow(11)"
        style="padding-left: 8px !important; padding-right: 2px!important;"
      >
        <span class="align-middle"
          >Commited {{ asset === "currencies" ? "" : fixing_type }}
        </span>
        <div
          v-bind:class="[
            showBasisRatio ? 'square-border-hedge' : 'square-border-hedge-off',
          ]"
        ></div>
      </button>

      <button
        class="btn detailView"
        :class="{ active: showHedge }"
        v-on:click="onShow(2)"
        style="padding-left: 8px !important; padding-right: 2px!important;"
      >
        <span class="align-middle">Hedge&nbsp;</span>
        <div
          v-bind:class="[
            showHedge ? 'square-border-dark-fwd' : 'square-border-dark-fwd-off',
          ]"
        ></div>
      </button>

      <button
        class="btn detailView"
        :class="{ active: showProgram }"
        v-on:click="onShowProgram"
      >
        <span class="align-middle inh">Program&nbsp;</span>
        <i
          class="fa fa-minus"
          style="color:var(--program)"
          v-if="showProgram"
        ></i>
        <i class="fa fa-minus" style="color:var(--textinactive)" v-else></i>
      </button>

      <!--    <button-->
      <!--      v-if="renderDetail && isButton"-->
      <!--      class="btn detailView"-->
      <!--      v-on:click="onShowDetailExpo"-->
      <!--      :class="{ onShowDetailView: showDetailExpo }"-->
      <!--    >-->
      <!--      <i class="fa fa-search"></i>-->
      <!--    </button>-->
      <!--    <span class="align-middle" v-show="renderDetail">&nbsp;Details</span>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "CurrencyPortfolioSelectors",
  props: {
    asset: { required: false, default: "currencies" },
    isBalancePortfolio: { required: false, type: Boolean, default: false },
    isButton: { required: false, type: Boolean, default: true },
    fixing_type: { required: false, default: "basis" },
    renderDetail: { required: false, type: Boolean, default: true },
    showDetailExpo: { required: true },
    showExpo: { required: true },
    showBasisRatio: { required: true },
    showHedge: { required: true },
    showNet: { required: true },
    showProgram: { required: true },
  },
  data() {
    return {};
  },
  methods: {
    onShow(val) {
      this.$emit("eventOnShow", val);
    },
    onShowDetailExpo() {
      this.$emit("eventOnShowDetailExpo");
    },
    onShowProgram() {
      this.$emit("eventOnShowProgram");
    },
  },
};
</script>

<style scoped></style>
